import { config } from '../lib';

import { createApiFor } from './createApi';

export const publisherApi = createApiFor(
  'publisher',
  `https://${config.API_ENDPOINT}`
);
